import { Avatar, Box, Chip, Divider, Typography } from "@mui/material";
import StoreIcon from "@mui/icons-material/Store";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
dayjs.extend(relativeTime);

const getInitials = (name = "") =>
  name.split(" ").filter(Boolean).map((w) => w[0]).join("").toUpperCase().slice(0, 2);

export const VendorReply = ({ reply }) => {
  if (!reply?.description) return null;

  return (
    <Box sx={{ mt: 1.5 }}>
      <Divider />
      <Box sx={{ display: "flex", alignItems: "flex-start", gap: 1.5, pt: 1.5, pl: 1 }}>
        {/* Vendor avatar — logo or initials */}
        <Avatar
          src={reply.avatar || undefined}
          sx={{ width: 28, height: 28, fontSize: 10, flexShrink: 0 }}
        >
          {!reply.avatar && (reply.name ? getInitials(reply.name) : <StoreIcon sx={{ fontSize: 14 }} />)}
        </Avatar>

        <Box sx={{ flexGrow: 1, minWidth: 0 }}>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 0.25 }}>
            <Typography variant="subtitle2" fontWeight={600}>
              {reply.name || "Restaurant"}
            </Typography>
            <Chip
              label="Owner"
              size="small"
              variant="outlined"
              sx={{ height: 18, fontSize: "0.65rem", borderRadius: 1 }}
            />
            {reply.editedDate && (
              <Typography variant="caption" color="text.disabled">• edited</Typography>
            )}
          </Box>

          <Typography variant="caption" color="text.secondary" display="block" sx={{ mb: 0.5 }}>
            {dayjs(reply.editedDate || reply.createdDate).fromNow()}
          </Typography>

          <Typography variant="body2" sx={{ wordBreak: "break-word" }}>
            {reply.description}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};
